// extracted by mini-css-extract-plugin
module.exports = {"div":"Sect4_Comp3_div__1U_vX","mobile":"Sect4_Comp3_mobile__17PPj"};